/**
 * @theme/show-more — toggles `.hidden` on `.show-more-item` siblings; focuses the first visible.
 * Replaces the original assets/show-more.js (kept the same filename + tag for drop-in compatibility).
 */

import { Component, defineComponent } from '@theme/component';

/**
 * @extends {Component}
 */
export class ShowMoreButton extends Component {
  /** @type {HTMLButtonElement | null} */
  button = null;

  connectedCallback() {
    super.connectedCallback();
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.button?.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    this.expandShowMore(event);
    const target = /** @type {Element} */ (event.target);
    const next = target.closest('.parent-display')?.querySelector('.show-more-item');
    if (next instanceof HTMLElement && !next.classList.contains('hidden')) {
      next.querySelector('input')?.focus();
    }
  };

  /** @param {MouseEvent} event */
  expandShowMore(event) {
    const target = /** @type {Element} */ (event.target);
    const parentDisplay = target.closest('[id^="Show-More-"]')?.closest('.parent-display');
    if (!parentDisplay) return;
    this.querySelectorAll('.label-text').forEach((el) => el.classList.toggle('hidden'));
    parentDisplay.querySelectorAll('.show-more-item').forEach((el) => el.classList.toggle('hidden'));
  }
}

defineComponent('show-more-button', ShowMoreButton);
